import { styled } from '@mui/material';

export const Root = styled('li')({
  height: 56,
});
